<template lang="pug">
  tr(@click="togglePractice()")
    td {{ practice.session_title }}
    td {{ practice.instructor_fullName }}
    td {{ duration }}
    td
      v-checkbox(
        :input-value="isSelectedPractice"
        primary
        hide-details)
</template>

<script>
    import { mapFields } from 'vuex-map-fields';
    import VueTypes from 'vue-types';
    export default {
        props: {
            practice: VueTypes.object.def({})
        },
        computed: {
            ...mapFields('businesses', {
                model: 'business'
            }),
            isSelectedPractice() {
                return this.model.definitions.sessions.some(
                    item => item.id === this.practice.session_id
                );
            },
            duration() {
                return this.practice.session_duration
                    ? `${parseInt(
                          this.practice.session_duration / 60,
                          10
                      )}min ${this.practice.session_duration % 60}sec`
                    : '';
            }
        },
        methods: {
            togglePractice() {
                this.isSelectedPractice
                    ? (this.model.definitions.sessions = this.model.definitions.sessions.filter(
                          item => item.id !== this.practice.session_id
                      ))
                    : this.model.definitions.sessions.push({
                          title: this.practice.session_title,
                          id: this.practice.session_id,
                          isLocked: this.practice.session_isLocked
                      });
            }
        }
    };
</script>
